module.exports = __webpack_public_path__ + "static/mental_health_banner-2064d4ea0ab65c5a0fa37b8eef308df3.jpg";